<template>
    <v-container fluid pa-0>


        <table style="width:100%">
            <tr>
                <th></th>
                <th>{{$t('statistics.headerTotal') }}</th>
                <th>{{$t('statistics.headerSelected') }} ( {{$store.state.yearRange.min }} - {{$store.state.yearRange.max }} )</th>
            </tr>
            <tr>
                <td>{{$t('statistics.titleTotal') }}:</td>
                <td><app-highlighted-text>{{ $store.state.totalObservations }}</app-highlighted-text></td>
                <td><app-highlighted-text>{{ $store.state.totalObservationsSelected }}</app-highlighted-text></td>
            </tr>
            <tr>
                <td> {{$t('statistics.titleBoxes') }}:</td>
                <td>        <app-highlighted-text> {{
                    $store.state.total5x5boxes }} {{$t('statistics.perBoxes') }}
                </app-highlighted-text></td>
                <td><app-highlighted-text> {{
                    $store.state.total5x5boxesSelected }} {{$t('statistics.perBoxes') }}
                </app-highlighted-text></td>
            </tr>

            <tr>           <td> <v-divider></v-divider></td> <td> <v-divider></v-divider></td> <td> <v-divider></v-divider></td>
            </tr>


            <tr>
                <td>{{$t('statistics.titleOldest') }}:</td>
                <td>
                    <app-highlighted-text>{{ $store.state.firstObservation }}</app-highlighted-text>
                </td>
                <td>
                    <app-highlighted-text>/</app-highlighted-text>

                </td>
            </tr>


            <tr>
                <td> {{$t('statistics.titleNewest') }}:</td>
                <td>
                    <app-highlighted-text>{{ $store.state.lastObservation }}</app-highlighted-text>
                </td>
                <td>
                    <app-highlighted-text>/</app-highlighted-text>
                </td>
            </tr>

            <tr>
                <td>  {{$t('statistics.titleLowest') }}:</td>
                <td>
                    <app-highlighted-text>{{ $store.state.lowestObservation }}</app-highlighted-text>
                </td>
                <td>
                    <app-highlighted-text>/</app-highlighted-text>
                </td>
            </tr>

            <tr>
                <td>  {{$t('statistics.titleHighest') }}:
                </td>
                <td>
                    <app-highlighted-text>{{ $store.state.highestObservation }}</app-highlighted-text>
                </td>
                <td>
                    <app-highlighted-text>/</app-highlighted-text>
                </td>
            </tr>
        </table>






    </v-container>
</template>

<script>
    import AppHighlightedText from '../AppComponents/AppHighlightedText'

    import axios from 'axios'
    import {speciesUrl} from '../../data/app-data'
    import {API_ERROR_MESSAGE} from '../../data/constants'

    export default {
        name: 'ObservationStatistics',
        components: {
            AppHighlightedText
        },

        computed: {
            isFungusApp() {
                return this.$store.getters.isFungusApp
            },
            taxonId() {
                return this.$store.state.taxonId
            }
        },
        watch: {
            taxonId() {
                this.getObservationInformation()
            }
        },
        methods: {
            resetObservationInformation() {
                this.$store.commit('resetObservationInformation')
            },

            getObservationInformation() {
                if (this.taxonId !== null && this.$store.state.totalObservations !== 0) {
                    axios.get(speciesUrl.observationFirst + this.taxonId).then((result) => {
                        this.$store.commit('setFirstObservation', new Date(result.data).getFullYear())
                    }).catch((error) => {
                        console.log(API_ERROR_MESSAGE, error)
                    })

                    axios.get(speciesUrl.observationLast + this.taxonId).then((result) => {
                        this.$store.commit('setLastObservation', new Date(result.data).getFullYear())

                    }).catch((error) => {
                        console.log(API_ERROR_MESSAGE, error)
                    })

                    axios.get(speciesUrl.observationLowest + this.taxonId).then((result) => {
                        this.$store.commit('setLowestObservation', result.data)
                    }).catch((error) => {
                        console.log(API_ERROR_MESSAGE, error)
                    })

                    axios.get(speciesUrl.observationHighest + this.taxonId).then((result) => {
                        this.$store.commit('setHighestObservation', result.data)
                    }).catch((error) => {
                        console.log(API_ERROR_MESSAGE, error)
                    })





                } else {
                    this.resetObservationInformation()
                }
            }
        },

        created() {
            this.getObservationInformation()
        }
    }
</script>

<style scoped>
    td, th {
        text-align: left;
        padding: 2px;
    }

    #app-infotable {
        margin-top: 10px;

    }

</style>